<template>
  <div class="sku-list">
    <div class="sku-single" v-for="(sku, index) in skuList" :key="index">
      <a
        href="javascript:;"
        class="jump-details"
        @click="
          jumpDetails(sku.item_id, sku.sku_id, sku.platform, sku.item_type)
        "
      >
        <div class="sku-details">
          <div class="sku-img">
            <img v-lazy="sku.pic_url" />
          </div>
          <div class="sku-intro">
            <div class="name">{{ sku.name }}</div>
            <div class="intro">{{ sku.simple_desc }}</div>
            <div class="price-rebate">
              <div class="price">{{ sku.market_price }}元起</div>
              <div class="rebate" v-show="sku.rebate">
                返{{ sku.rebate }}福利金
              </div>
            </div>
          </div>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
import api from '../../utils/api'
import { mapState } from 'vuex'
let flag = false
export default {
  name: 'productSingle',
  props: {
    skuList: {
      type: Array
    }
  },
  computed: {
    ...mapState('store', [
      'Authorization'
    ]),
    rebate (sku) {
      return sku => {
        return sku.activity || sku.equity
      }
    }
  },
  methods: {
    /**
     * 跳转商品详情
     * @param(String) goodsid 商品id
     * @param(String) skuid  商品skuid
     * @param(String) paltform 平台标识
     */
    async jumpDetails (goodsid, skuid, platform, type) {
      if (flag) {
        return false
      }
      flag = true
      await api.routeJump({ goodsid, skuid, platform, type })
      flag = false
    }
  }
}
</script>

<style lang="less" scoped>
.sku-single {
  margin-top: 0.2rem;
  background-color: #fff;
  .sku-details {
    color: @base;
    .flex-between;
    position: relative;
  }
  .sku-img {
    width: 2.6rem;
    height: 2.6rem;
    padding: 0 0.2rem;
    img {
      object-fit: contain;
    }
  }
  .sku-intro {
    width: 4rem;
    height: 2.15rem;
    padding-right: 0.2rem;
    .flex-column-between;
    .name,
    .intro {
      width: 4rem;
      font-size: @fz28;
      color: @base;
      .ellipsis2;
    }
    .intro {
      padding-top: 0.2rem;
      color: @c80;
      font-size: @fz24;
    }
    .price-rebate {
      .flex-between;
      font-size: @fz24;
      color: @price;
    }
    .sku-tips {
      position: absolute;
      right: 0.2rem;
      bottom: 0.2rem;
      // width: 1.52rem;
      padding: 0 0.1rem;
      height: 0.48rem;
      border-radius: 30px;
      background-color: #ffeaef;
      font-size: @fz20;
      color: @price;
      .flex-center;
    }
  }
}
</style>
